'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
/**
 *  Copyright (c) 2017, Applitopia, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the MIT-style license found in the
 *  LICENSE file in the root directory of this source tree.
 *
 *  
 */


var _SubActionFactory = require('./SubActionFactory');

var _SubActionFactory2 = _interopRequireDefault(_SubActionFactory);

var _BoundActionFactory = require('./BoundActionFactory');

var _BoundActionFactory2 = _interopRequireDefault(_BoundActionFactory);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var SubEngine = function () {
  function SubEngine(engine, subSchemaPath) {
    _classCallCheck(this, SubEngine);

    this._engine = engine;
    this._subSchemaPath = subSchemaPath;
    this._prefix = subSchemaPath + '.';
    this._actionFactory = new _SubActionFactory2.default(this._engine.actionFactory(), this._subSchemaPath);
  } // Extract a value from state


  _createClass(SubEngine, [{
    key: 'get',
    value: function get(state, name) {
      if (!name) {
        return this._engine.get(state, this._subSchemaPath);
      }

      var prefix = this._prefix + name;
      return this._engine.get(state, prefix);
    } //
    // Subscribe to all actions created by this engine
    //
    // Returns a function to unsubscribe
    //

  }, {
    key: 'subscribe',
    value: function subscribe(listener) {
      return this._engine.subscribe(listener);
    } //
    // Remove all internal items from the state
    //

  }, {
    key: 'printableState',
    value: function printableState(state) {
      var subState = this.get(state, undefined);
      subState = this._engine.printableState(subState);
      return subState;
    }
  }, {
    key: 'persistableState',
    value: function persistableState(state) {
      var subState = this._engine.persistableState(state);

      subState = this.get(state, undefined);
      return subState;
    } //
    // Repo Functions
    //

  }, {
    key: 'currentBranch',
    value: function currentBranch(repo) {
      if (!repo) {
        throw Error("repo not defined");
      }

      var currentBranch = repo.get("currentBranch");
      return currentBranch;
    }
  }, {
    key: 'currentBranchState',
    value: function currentBranchState(repo) {
      var st = this._engine.currentBranchState(repo);

      return st;
    }
  }, {
    key: 'live',
    value: function live(repo) {
      var branch = this.currentBranchState(repo);
      return branch.get("live");
    }
  }, {
    key: 'head',
    value: function head(repo) {
      var st = this._engine.head(repo);

      return st;
    }
  }, {
    key: 'prev',
    value: function prev(repo) {
      var st = this._engine.prev(repo);

      return st;
    } // SubEngine

  }, {
    key: 'subEngine',
    value: function subEngine(subSchemaPath) {
      return this._engine.subEngine(this._prefix + subSchemaPath);
    } // ActionFactory

  }, {
    key: 'actionFactory',
    value: function actionFactory() {
      return this._actionFactory;
    }
  }, {
    key: 'boundActionFactory',
    value: function boundActionFactory(dispatch) {
      return new _BoundActionFactory2.default(dispatch, this.actionFactory());
    } //
    // Compile the reducer
    //

  }, {
    key: 'stateReducer',
    value: function stateReducer() {
      throw new Error("Reducer is not implemented in SubEngine");
    }
  }, {
    key: 'repoReducer',
    value: function repoReducer() {
      throw new Error("RepoReducer is not implemented in SubEngine");
    }
  }]);

  return SubEngine;
}();

exports.default = SubEngine;